
  import '/home/ec2-user/Youlify-Design/components/pagination/index.$tab-design.zh-CN.md?watch=parent';
  export const texts = [{"value":"Pagination的本质是控制单页内信息数量，可跳转页面。","paraId":0,"tocIndex":0}];
  